import React from "react";
import { Button, Col, InputGroup, Label, Row } from "reactstrap";

/** The description textarea of a row; attributes it is not given are not rendered. */
export type VariableArrayRowTextarea = {
  rows: number;
  placeholder: string;
  value: string | undefined;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
  name: string;
  className?: string;
};

export type VariableArrayRowProps = {
  /** The wrapping div's class, e.g. `infotext-item`. */
  className: string;
  topRowClassName: string;
  topLabel: string;
  /** The field's own columns between the top label and the remove button. */
  children: React.ReactNode;
  onRemove: () => void;
  removeDisabled?: boolean;
  removeColClassName?: string;
  bottomRowClassName: string;
  bottomLabel: string;
  textarea: VariableArrayRowTextarea;
};

/**
 * One item of a repeatable content variable (SCRUM-2121): a top row with a
 * label, the field's own inputs and a remove button, and a description row
 * with a textarea. ContentArrayContent, Infotext, Tips, ContentService (update)
 * and BottomBlockRight render their items through it; what differs per field
 * arrives as props, so the markup is the one each field rendered before
 * (pinned by tests/integration/variables/variableArrayRow.snapshots.test.tsx).
 */
const VariableArrayRow = ({
  className,
  topRowClassName,
  topLabel,
  children,
  onRemove,
  removeDisabled,
  removeColClassName,
  bottomRowClassName,
  bottomLabel,
  textarea,
}: VariableArrayRowProps) => (
  <div className={className}>
    <Row className={topRowClassName}>
      <Label md="2" className="form-control-label">{topLabel}</Label>
      {children}
      <Col md="1" className={removeColClassName}>
        <Button type="button" color="danger" size="sm" onClick={onRemove} disabled={removeDisabled}>
          &minus;
        </Button>
      </Col>
    </Row>
    <Row className={bottomRowClassName}>
      <Label md="2" className="form-control-label">{bottomLabel}</Label>
      <Col md="10">
        <InputGroup className="input-group-merge">
          <textarea
            rows={textarea.rows}
            cols={70}
            placeholder={textarea.placeholder}
            value={textarea.value}
            onChange={textarea.onChange}
            name={textarea.name}
            className={textarea.className}
          />
        </InputGroup>
      </Col>
    </Row>
  </div>
);

export default VariableArrayRow;
